import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {TranslationMessage} from '../../models/translation/translation-message';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class TranslationMessageService extends AbstractModelService<TranslationMessage> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/translation-message', TranslationMessage);
  }

  writeMessage(domainId: number, locale: string, key: string, text: string): Observable<any> {
    return new Observable<void>((subscriber: Subscriber<any>): void => {
      const params = {
        domainId,
        locale,
        key,
        text
      };

      this.apiClient.post(this.routePath, {}, params).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
